// import fetchJsonp from 'fetch-jsonp';
// import { NetInfo } from 'common/widget/Community';
// import FormEncode from 'utils/form-urlencoded';
// import ServerTime from 'utils/serviceTime';
import Utils from 'utils/utils';
import YPStatSend from 'utils/YPStatSend';
import { performanceStat } from 'base/navigator/performanceStat';
import Cookie from 'common/Cookie';
import AuthUtil from 'common/AuthUtil';
import Monitor from 'utils/monitor/index';

import { LOGIN_URL } from './config';

const ypStatSend = new YPStatSend({});
const reportTraceId = async (response, url, page) => {
  try {
    const traceId = response.headers.get('x-trace-id');
    if (url.indexOf('stat') < 0) {
      ypStatSend.info('trace_id', `tag=${traceId || ''}&u=${encodeURIComponent(url)}`, {
        pageName: page,
      });
    }
  } catch (e) {}
};

export const getMakeTime = async () => {
  return 0;
};
const getJsonp = (url) => {
  return new Promise((resolve) => {
    window.__mishop_jsonp = (val) => {
      resolve(val);
    };
    window.hdinfo = (val) => {
      resolve(val);
    };
    const script = document.createElement('script');
    if (url.indexOf('jsonpcallback') > -1) {
      script.src = url;
    } else {
      script.src = url + `${url.indexOf('?') > -1 ? '&' : '?'}jsonpcallback=__mishop_jsonp`;
    }
    document.body.appendChild(script);
  });
};
const request = {
  // 添加X-User-Agent协议
  // https://wiki.n.miui.com/pages/viewpage.action?pageId=201097923&moved=true
  addXUserAgentToHeader(header) {
    const channel = 'mishop';
    const appName = 'mishop.m'; // CommonBridge.AppKey;
    header['X-User-Agent'] = `channel/${channel} platform/${appName.toLowerCase()}`;
    return header;
  },

  getHeaders() {
    return this.addXUserAgentToHeader({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Mishop-App-Source': 'front-RNWeb',
    });
  },
  getNoCacheHeaders() {
    return {
      'Cache-Control': 'no-cache',
      'X-Mishop-App-Source': 'front-RNWeb',
    };
  },

  // async isNetworkConnected() {
  //   return await NetInfo.isConnected.fetch();
  // },

  async bslFetchData(url, data, showLogin, resultIsJson, isOrigin) {
    if (resultIsJson) {
      return await this.fetchData(url, data, showLogin, 0, isOrigin);
    } else {
      return await this.fetchDataRepeat(url, data, resultIsJson);
    }
  },

  // deep: 0(showLogin：true->强制登录 false -> callback) 1: callback 其他(2)：抛出异常
  async unloginResponse(response, deep, showLogin, callback) {
    if (deep == 0 && showLogin) {
      const client_id = '180100031051';
      window.location.href = `${location.protocol}//${
        location.host
      }/v1/authorize/sso?client_id=${client_id}&_snsNone=true&callback=${encodeURIComponent(location.href)}`;
      // window.location.href = `${LOGIN_URL}?_loginType=ticket&followup=` + encodeURIComponent(location.href);
    } else if (deep < 2) {
      return await callback();
    } else {
      const error = new Error('操作失败，请退出账号后重新登录');
      error.response = response;
      error.code = 401;
      return error;
    }
  },

  async handleResponse(params) {
    try {
      const response = await (params.getResponseResult && params.getResponseResult());
      if (!response) {
        const error = new Error('Server not response');
        error.response = 'no data response';
        throw error;
      } else if (response.ok || response.statusText === 'OK') {
        try {
          const handleResponseResult = await (params.handleResponse && params.handleResponse(response));
          return handleResponseResult;
        } catch (err) {
          const error = new Error('Error Text ');
          error.response = 'error Text format';
          throw error;
        }
      } else if (response.status == 401) {
        const unloginResponseResult = await (params.unloginResponse && params.unloginResponse(response));
        return unloginResponseResult;
      } else {
        const error = new Error('Request Error');
        error.response = response;
        throw error;
      }
    } catch (error) {
      if (error && error.response && error.response.status == 502) {
        throw new Error('网络异常，请稍后再试');
      } else {
        throw error;
      }
    }
  },

  async fetchDataRepeat(url, data, resultIsJson) {
    return this.handleResponse({
      getResponseResult: async () => {
        const page = Utils.getCache('navigatorName') || undefined;
        const resp = await Monitor.apiWrapper(fetch)(url, data);
        reportTraceId(resp, url, page);
        return resp;
      },
      handleResponse: async (response) => {
        let jsondata;
        if (resultIsJson) {
          jsondata = await response.json();
        } else {
          jsondata = await response.text();
        }

        // gateway接口 401时response.status为200 但是code为401
        if (jsondata && jsondata.code && [401, 999999999301, 999999999302].includes(jsondata.code)) {
          this.unloginResponse(response, 2);
          return;
        }

        return jsondata;
      },
      unloginResponse: (response) => this.unloginResponse(response, 2),
    });
  },

  async fetchData(url, post, showLogin, deep, isOrigin) {
    const time = Date.now();
    const tag = `${time}_${Math.random()}`;
    // 统计首次加载数据网络请求时间
    if (url.indexOf('stat/') === -1) {
      performanceStat.recordReqTag(tag);
    }
    if ((url.indexOf('hd.test.mi.com') > -1 || url.indexOf('tp.hd.mi.com') > -1) && url.indexOf('gettimestamp') < 0) {
      const userInfo = await AuthUtil.getUserInfo();
      if (userInfo.user_id) {
        Cookie.setCookie('userId', userInfo.user_id, 'tp.hd.mi.com');
      }
      const resp = await getJsonp(url);
      if (url.indexOf('hdinfo/cn') > -1 || url.indexOf('hdget/cn') > -1) {
        return {
          code: 0,
          data: resp,
        };
      }
      return resp;
      // reportTraceId(resp, url, 'product');
      // let text = await resp.text();
      // if (text.indexOf('hdinfo(') === 0) {
      //   text = text.replace('hdinfo(', '');
      //   text = text.substring(0, text.length - 1);
      //   text = JSON.parse(text);
      //   return {
      //     code: 0,
      //     data: text,
      //   };
      // }
      // if (url.indexOf('tp.hd.mi.com/gettimestamp') > -1) {
      //   return text;
      // }
    }
    return this.handleResponse({
      getResponseResult: async () => {
        const page = Utils.getCache('navigatorName') || undefined;
        const resp = await Monitor.apiWrapper(fetch)(url, {
          ...post,
          headers: {
            ...post.headers,
            'mishop-client-id': Cookie.getCookie('client_id') || '180100031051',
            'Mishop-Channel-Id': 'channel',
          },
          credentials: 'include',
        });
        reportTraceId(resp, url, page);
        return resp;
      },

      handleResponse: async (response) => {
        const jsondata = await response.json();
        performanceStat.recordRequestTime(tag, Date.now() - time);
        // gateway接口 401时response.status为200 但是code为401
        if (jsondata && jsondata.code == 401) {
          const unloginResponse = await this.unloginResponse(response, deep, showLogin, () =>
            this.fetchData(url, post, showLogin, deep + 1),
          );
          return unloginResponse;
        }

        if (jsondata && jsondata.timestamp) {
          Utils.setcurrentTime(jsondata.timestamp);
          // ServerTime.setcurrentTime(jsondata.timestamp);
        }
        if (isOrigin) {
          return jsondata;
        }
        return jsondata.result || jsondata;
      },
      unloginResponse: (response) =>
        this.unloginResponse(response, deep, showLogin, () => this.fetchData(url, post, showLogin, deep + 1)),
    });
  },

  async fetchDataString(url, method, resultIsJson, isNoCache) {
    const data = {};
    data.method = 'GET';
    data.credentials = 'include';
    if (isNoCache) {
      data.headers = await this.getNoCacheHeaders();
    }
    url = url.replace('shopapi.io.mi.com', 'm.youpin.mi.com');
    return this.handleResponse({
      getResponseResult: () => Monitor.apiWrapper(fetch)(url, data),
      handleResponse: async (response) => {
        let jsondata;
        if (resultIsJson) {
          jsondata = await response.json();
        } else {
          jsondata = await response.text();
        }

        if (jsondata && jsondata.code == 401) {
          this.unloginResponse(response, 0, true);
          return;
        }
        return jsondata;
      },
      unloginResponse: (response) => this.unloginResponse(response, 0, true),
    });
  },

  // async fetchDataStringNoCache(url, method, resultIsJson) {
  //     let data = {};
  //     data.method = "GET";
  //     data.credentials = 'include';
  //     data.headers = await this.getNoCacheHeaders();
  //     url = url.replace("shopapi.io.mi.com", 'm.youpin.mi.com');
  //     return this.handleResponse({
  //         getResponseResult: () => fetch(url, data),
  //         handleResponse: async (response) => {
  //             let jsondata;
  //             if (resultIsJson) {
  //                 jsondata = await response.json();
  //             } else {
  //                 jsondata = await response.text();
  //             }
  //             if(jsondata && jsondata.code == 401){
  //                 this.unloginResponse(response, 0, true);
  //                 return;
  //             }
  //             return jsondata;
  //         },
  //         unloginResponse: (response) => this.unloginResponse(response, 0, true)
  //     })
  // },

  // async fetchJsonp(url, callback) {
  //   return this.handleResponse({
  //     getResponseResult: () => fetchJsonp(url, { timeout: 5000, jsonpCallbackFunction: callback }),
  //     handleResponse: async (response) => {
  //       let jsondata;
  //       jsondata = await response.json();
  //       if (jsondata && jsondata.code == 401) {
  //         this.unloginResponse(response, 0, true);
  //         return;
  //       }
  //       return jsondata;
  //     },
  //     unloginResponse: (response) => this.unloginResponse(response, 0, true),
  //   });
  // },

  /**
     * 请求数据data的格式为 showLogin 表示如果后端返回401 是否要显示登陆窗口
     * {
        showLogin: true,
        body: params
        }
     */
  // async requestData(url, data) {
  //   return await this.requestWithSpecifiedKey(url, data, 'data');
  // },

  /**
   * 后台获取数据
   * @param url 请求的url
   * @param data 请求的数据,是一个object,默认包一层body.
   * @param key 如果指定了key,则post的数据格式为@code{$key=data.body},如果没有指定key,则将data.body解析成key=vaule格式.
   * @return 返回的数据报文.
   * @throws #Error 401或其他错误
   */
  // async requestWithSpecifiedKey(url, data, key) {
  //   data = data || {};
  //   data.method = 'POST';
  //   data.headers = this.getHeaders();
  //   data.credentials = 'include';
  //   data.headers.DToken = '';
  //   if (key) {
  //     const obj = {};
  //     try {
  //       obj[key] = JSON.stringify(data.body);
  //       data.body = FormEncode(obj);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   } else {
  //     data.body = FormEncode(data.body);
  //   }
  //   return await this.fetchData(url, data, data.showLogin || false, 0);
  // },

  /**
   * 发送上传请求
   * @param url
   * @param data (以name、value存储)
   * @returns {*}
   */
  async sendFormData(url, data) {
    const options = {};
    options.method = 'POST';
    options.credentials = 'include';

    const formData = new FormData();

    if (Array.isArray(data)) {
      for (const item of data) {
        formData.append(item.name, item.value);
      }
    } else {
      formData.append(data.name, data.value);
    }

    options.body = formData;
    return await this.fetchData(url, options, options.showLogin || false, 0);
  },
  requestOldInterface() {
    return Promise.resolve();
  },
};

export { request };
